var render = function render(){var _vm=this,_c=_vm._self._c;return _c('veui-layout',{staticClass:"basic-container",class:{
        'basic-container-no-bg': _vm.noBackground,
        'is-style-v2': _vm.isStyleV2,
        [`is-style-v2-${_vm.activeTheme}`]: true,
    }},[[_c('qingduo-header-v2')],_c('veui-content',[_c('router-view',{key:_vm.$route.name})],1),(!_vm.hideFooter)?_c('veui-footer',[_c('div',{staticClass:"copyright"},[_vm._v(_vm._s(_vm.copyright))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }